import styled, { css } from 'styled-components';
import Button from '../../../_shared/components/Button';
import isOmpPlatform from '../../../_shared/utils/isOmpPlatform';

const isOmp = isOmpPlatform();

export const VehicleDetailsContainer = styled.div`
  margin-top: 4px;
  max-width: 480px;
  grid-column-start: 1;

  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    margin: 20px;
    padding: 0;
    order: 3;
  }
`;

export const Section = styled.section`
  padding: 32px 0;
  border-bottom: 1px solid
    ${({ theme }) =>
      isOmp ? theme.COLORS.NEUTRAL_110 : theme.COLORS.NEUTRAL_30};

  &:last-child {
    border-bottom: none;
  }

  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    &:first-child {
      padding-top: 0;
    }
  }
`;

export const Title = styled.h2`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  && {
    margin-bottom: 36px;
  }
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const Specification = styled.div`
  display: flex;
  align-items: flex-start;
  min-width: calc(100% / 3);
  margin-bottom: 42px;

  @media only screen and (max-width: ${({ theme }) =>
    theme.BP.RETAIL_CUSTOM_MOBILE_SMALL}) {
      min-width: 50%;
  }

  svg {
    max-height: 20px;
    height: 24px;
    width: 24px;

    /* path {
      fill: ${({ theme }) => theme.COLORS.BASE_INVERTED};
    } */
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SpecificationInfoContainer = styled.div`
  margin-left: 12px;
`;

export const SpecificationLabel = styled.p`
  margin: 0 0 12px 0;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
`;

export const SpecificationValue = styled.p`
  margin: 0;
`;

export const StyledButton = styled(Button.Transparent)`
  height: 36px;
  border: 2px solid ${({ theme }) => theme.COLORS.BASE_INVERTED};
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 24px;
  align-items: center;
  flex-direction: row;
  display: flex;
  top: 30px;
  right: 36px;

  &:hover {
    color: ${({ theme }) => theme.COLORS.DARK_BLUE};
    border: 2px solid ${({ theme }) => theme.COLORS.DARK_BLUE};
  }

  img {
    margin-left: 9px;
  }
`;

export const VhrLogo = styled.img``;

const hasFeatures = {
  false: css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    & > li {
      margin-bottom: 0;
    }
  `
};

export const FeaturesContainer = styled.ul`
  & > li {
    margin-bottom: 30px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ${props => hasFeatures[props.hasFeatures]}
`;

export const Category = styled.ul``;

export const CategoryTitle = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid
    ${({ theme }) =>
      isOmp ? theme.COLORS.NEUTRAL_110 : theme.COLORS.NEUTRAL_50};
  padding-bottom: 12px;
  margin-bottom: 18px;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  svg {
    height: 18px;
    width: 18px;
  }
`;

export const FeatureContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const FeatureLabel = styled.p`
  margin: 0 0 0 12px;
`;

export const Feature = styled.li`
  && {
    list-style: initial;
  }
  margin: 18px 0 0 24px;
  width: calc(50% - 24px);

  &:first-child,
  &:nth-child(2) {
    margin-top: 0;
  }
`;

export const Description = styled.p`
  white-space: pre-wrap;
`;
